const Products = {
  0: { name: 'Money', voucherProductTypeId: 0, code: 'MONEY' },
  1: { name: 'PS Plus', voucherProductTypeId: 1, code: 'PSPLUS' },
};

export default Products;
